module.exports = __webpack_public_path__ + "static/img/is2.99132bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institute/pic/is2.jpg
// module id = H4fc
// module chunks = 11